// @vue/component
export default {
  name: 'ReportsListSearchPanel',

  props: {
    isLoading: {
      type: Boolean,
      defaul: false,
    },
  },

  data() {
    return {
      isSubmitForm: false,
      inputsModel: {
        name: '',
        is_global: '',
      },
      rules: {
        name: [
          { min: 3, message: 'Długość nazwy musi posiadać minimalnie 3 znaki.', trigger: 'blur' },
        ],
      },
    };
  },

  methods: {
    submitSearchForm() {
      this.$refs.searchForm.validate(async (valid) => {
        if (valid) {
          this.__changeStateSubmitForm(true);
          await this.$store.dispatch('reports/filterList', this.inputsModel);
          this.__changeStateSubmitForm(false);
        }
      });
    },
    __changeStateSubmitForm(state = false) {
      this.isSubmitForm = state;
    },
  },
};
